import withLazy from '../../hoc/with-lazy';
import forDevice from '../../hoc/for-device';
const MemberCardLazy = withLazy({
    importFn: () => import(/* webpackChunkName: "wc-member-card" */ './member-card'),
    errorHandling: { type: 'HANDLE' },
});
// don't need to render member card on mobile
const DummyCard = () => null;
export default forDevice(DummyCard, MemberCardLazy);
//# sourceMappingURL=member-card-lazy.js.map